import { ReduxHelper } from "helpers";
import {
  ICreateProductRequest,
  IDeleteByIdRequest,
  IGetAllProductResponse,
  IGetByIdRequest,
  IPaginationRequest,
  IProduct,
  IUpdateProductPackingRequest,
  IUpdateProductRequest,
} from "model";

export const prefix = "PRODUCT";

export const getAllProducts = ReduxHelper.generateActions<
  IPaginationRequest,
  IGetAllProductResponse
>(prefix, "GET_ALL_PRODUCTS");
export const getProductById = ReduxHelper.generateActions<
  IGetByIdRequest,
  IProduct
>(prefix, "GET_PRODUCT_BY_ID");
export const createProduct = ReduxHelper.generateActions<
  ICreateProductRequest,
  IProduct
>(prefix, "CREATE_PRODUCT");
export const updateProduct = ReduxHelper.generateActions<
  IUpdateProductRequest,
  IProduct
>(prefix, "UPDATE_PRODUCT");
export const deleteProduct = ReduxHelper.generateActions<
  IDeleteByIdRequest,
  { id: string }
>(prefix, "DELETE_PRODUCT");
export const updateProductPacking = ReduxHelper.generateActions<
  IUpdateProductPackingRequest,
  any
>(prefix, "UPDATE_PRODUCT_PACKAGING");
export const clearReducer = ReduxHelper.generateLocalAction(
  prefix,
  "CLEAR_REDUCER"
);
